<template>
  <section class="categories">
    <div style="display: flex;flex-direction: column;justify-content: center">
      <h2 style="color: black;">岗位全、人更多、招得快，满足所有招聘场景</h2>

      <CustomTab
        v-model="activeTab"
        :tabList="categories"
        @change="handleMenuChange"/>

      <div class="tab-content">
        <img :src="currentTab.image" class="imgDesc">
        <div class="content-text">
          <h3>{{ currentTab.title }}</h3>
          <p>{{ currentTab.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CustomTab from "@/views/toc/CustomTab.vue";
export default {
  name: 'CategoriesSection',
  components: { CustomTab},
  data() {
    return {
      categories: [
        {
          name: '餐饮服务',
          title: '「灵活用工」让餐饮企业用人更轻松',
          image: require('@/assets/img/eat.png'),
          description: '兼职直聘聚集大量餐饮岗位人才，高峰期招人快、换班灵活不耽误营业，帮餐饮商家稳住人手、减少用工空档。'
        },
        {
          name: '超市零售',
          title: '「短时用工」解决人多事杂的用工难题',
          image: require('@/assets/img/market.png'),
          description: '无论是节假日人流高峰还是促销活动，兼职直聘都能快速匹配合适人手，帮商家灵活补位、降本提效。'
        }, {
          name: '市场推广',
          title: '「活动人手」临时招人不再愁',
          image: require('@/assets/img/ipad.png'),
          description: '兼职直聘拥有大量推广、派单、执行类人才资源，报名快、响应快，让每一场活动都能高效落地。'
        }, {
          name: '物流仓储',
          title: '「高峰应援」助力仓储物流稳产提速',
          image: require('@/assets/img/wuliu.png'),
          description: '订单多、人手紧？兼职直聘帮你快速找到打包、分拣、搬运等岗位人员，缓解旺季用工压力。'
        }, {
          name: '司机骑手',
          title: '「灵活调度」让跑单更自由',
          image: require('@/assets/img/driver.png'),
          description: '无论全职还是兼职，兼职直聘都能为你快速找到配送骑手、网约司机等岗位人选，提升运力，响应更快。'
        }, {
          name: '主播艺人',
          title: '「短期合作」打造内容更灵活',
          image: require('@/assets/img/shower.png'),
          description: '兼职直聘聚合各类主播、演员、模特资源，支持按场次、按小时合作，助力品牌直播、短视频内容创作。'
        }, {
          name: '产品代理',
          title: '「兼职带货」拓展品牌新渠道',
          image: require('@/assets/img/hezuo.png'),
          description: '兼职直聘聚合海量兼职销售与代理人资源，帮企业低成本拓展市场，轻松提升产品曝光与销量。'
        },
      ],
      activeTab: 0,
      currentTab: undefined,
    };
  },
  methods: {
    handleMenuChange(item) {
      this.currentTab = item;
    }
  },
  created() {
    this.currentTab = this.categories[0];
  }
}
</script>

<style scoped>
.categories {
  padding: 60px 0;
  background-color: white;
}

h2 {
  font-size: 32px;
  margin-bottom: 40px;
  text-align: center;
}

.tab-content {
  padding: 30px 40px;
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.content-text {
  width: 443px;
  height: 183px;
  margin-left: 76px;
  background: #F3F3F3;
  border-radius: 15px;
  padding: 18px 18px 75px 18px;
}

.content-text h3 {
  display: flex;
  flex-direction: column;
  font-size: 20px;
  margin-top: 0;
  color: black;
}

.content-text p {
  margin-top: 18px;
  font-size: 16px;
  line-height: 1.8;
  color: #6C6C6C;
}

.imgDesc {
  width: 324px;
  height: 183px;

  /* 3. 核心裁切设置：使用 cover 模式，裁剪多余部分 */
  object-fit: cover;
  /* 4. 核心定位设置：让图片顶部对齐，从顶部开始裁剪 */
  object-position: 50% 50%;
}

@media screen and (max-width: 768px) {
  .categories {
    padding: 20px;
  }

  h2 {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .tab-content {
    padding: 15px 20px;
  }

  .content-text {
    height: 85px;
    margin-left: 16px;
    padding: 10px 8px 8px 8px;
  }

  .content-text h3 {
    font-size: 9px;
  }

  .content-text p {
    margin-top: 5px;
    font-size: 8px;
    line-height: 12px;
  }

  .imgDesc {
    width: 142px;
    height: 85px;

    /* 3. 核心裁切设置：使用 cover 模式，裁剪多余部分 */
    object-fit: cover;
    /* 4. 核心定位设置：让图片顶部对齐，从顶部开始裁剪 */
    object-position: 50% 50%;
  }
}

</style>
